import { useLanguageContext } from "../../../../context/LanguageContext";
import CapacityConfigsPage from "../../../../pages/integrations/capacity/CapacityConfigsPage";
import { useCapacityConfigsRouteValidator } from "../../../validators/integrations/capacity/CapacityConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useCapacityConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/capacity")
    .setLabel(translate("eva.main.entities.capacity_config"))
    .setValidator(useCapacityConfigsRouteValidator())
    .setPage(<CapacityConfigsPage />);
}

export default useCapacityConfigsRouteConfig;
